import React, {useState, useEffect} from 'react'

import "./Situations.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"
import DataTable from "../../shared/datatable/DataTable"
import axios from 'axios'
import SituationEditor from './Editor'
import VideocamIcon from '@mui/icons-material/Videocam';
import { format } from 'fecha';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

const Situations = () => {
  const [editorState, setEditorState] = useState({open: false, data: null})
  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })

  const [errors, setErrors] = useState("")
  const [search, setSearch] = useState("")
  const [managerType, setManagerType] = useState(0)

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/situations/getlist?search=' + search + '&type=' + managerType)
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const model = {
    columns: [
      {
        field: "SequenceNumber",
        headerName: "S.No.",
        width: 80,
      },
      {
        field: "Name",
        headerName: "Name",
        width: 150,
        renderCell: (params) => {
          return (
            <div className="cellWithLink" onClick={()=> handleOnCellClick(params)}>
              {params.row.Name}
            </div>
          );
        },
      },
      {
          field: "Heading",
          headerName: "Heading",
          width: 250
      },
        {
          field: "ManagerType",
          headerName: "Type",
          width: 100,
          renderCell: (params)=>{
            return(
              <span>{params.row.ManagerType == 1 ? "FTM" : (params.row.ManagerType == 2 ? "MM" : "OTR")}</span>
            );
          }
        },
        {
          field: "ImageUrl",
          headerName: "Image",
          width: 80,
          renderCell: (params) => {
            return (
              <div className="cellWithImg">
                <img className="cellImg" src={ axios.defaults.baseURL + '/' + (params.row.ImageUrl == "" ? "\\assets\\situations\\image\\52E784DA-B4E4-47CB-BE16-34DF6CCBD35C.png": params.row.ImageUrl)} alt="avatar" />
              </div>
            );
          },
        },
        // {
        //   field: "AudioUrl",
        //   headerName: "Audio",
        //   width: 80,
        //   renderCell: (params) => {
        //     return (
        //       <div className={params.row.AudioUrl  ? "available" : "not-available"}>
        //         <AudiotrackIcon />
        //       </div>
        //     );
        //   },
        // },
        {
          field: "VideoUrl",
          headerName: "Video",
          width: 80,
          renderCell: (params) => {
            return (
              <div className={params.row.VideoUrl  ? "available" : "not-available"}>
                <VideocamIcon />
              </div>
            );
          },
        },
        {
          field: "ShowVideo",
          headerName: "Show Video",
          width: 150,
          renderCell: (params) => {
            return (
              <div className={`cellWithStatus ${params.row.ShowVideo}`}>
               <span>{params.row.ShowVideo && "YES"}{!params.row.ShowVideo && "NO"}</span>
              </div>
            );
          },
        },
        {
          field: "ModifiedBy",
          headerName: "Modified By",
          width: 120,
        },
        {
          field: "ModifiedOn",
          headerName: "Modified On",
          width: 150,
          renderCell: (params)=>{
            return(
              params.row.ModifiedOn &&
              <span>{format(new Date(params.row.ModifiedOn), 'DD/MM/YYYY HH:mm')}</span>
            );
          }
        }
    ],
    modulename: "Situations"
  };

  const handleOnCellClick = (params) => {
    setEditorState({ open: true, data: params.row});
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={model.modulename}/>
        <ErrorMessages message={errors}/>
        {
          editorState.open == true ? 
          <SituationEditor data={editorState} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} /> : 
          <DataTable  {...model} rows={pageData.data} checkboxSelection={true} setEditorState={setEditorState} setPageState={setPageState} setSearch={setSearch} setManagerType={setManagerType}  />
        }
      </div>
    </div>
  )
}

export default Situations